import { ChangeEvent, useRef } from 'react';
import type Reaptcha from 'reaptcha';
import useLoginOrSignupSubmit from './helpers/useLoginOrSignupSubmit';
import type AuthStepsEnum from '../AuthStepsEnum';
import useStepByStepAuthContext from '../context/hooks/useStepByStepAuthContext';

type Props = {
  onContinueClick: (step: AuthStepsEnum) => void;
};

const useLoginOrSignupStep = ({ onContinueClick }: Props) => {
  const {
    control,
    errors,
    required,
    formState,
    registrationCaptchaRequired: captchaRequired,
    setValue,
  } = useStepByStepAuthContext();
  const { loading, handleSubmit } = useLoginOrSignupSubmit({ onContinueClick });

  const recaptchaRef = useRef<Reaptcha>(null);
  const isSubmitDisabled = !formState?.isValid || !formState.isDirty;

  const handleUserNameChange = (e: ChangeEvent<HTMLInputElement>) => {
    e.preventDefault;
    setValue?.('username', e.target.value, {
      shouldValidate: true,
      shouldDirty: !formState?.isDirty,
    });
  };

  return {
    required,
    errors,
    captchaRequired,
    control,
    recaptchaRef,
    loading,
    isSubmitDisabled,
    handleSubmit,
    handleUserNameChange,
  };
};

export default useLoginOrSignupStep;
